// eslint-disable-next-line import/extensions
import vForm from './v-form.jsx';

vForm.install = (Vue) => {
  Vue.component(vForm.name, vForm);
};

export default vForm;
